'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _antd = require('@adparlor-devops/antd');

var _components = require('../../../components');

var _Blueprint = require('../../../components/Blueprint');

require('./CreateBlueprints.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateBlueprints = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(CreateBlueprints, _Component);

  function CreateBlueprints() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CreateBlueprints);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CreateBlueprints.__proto__ || (0, _getPrototypeOf2.default)(CreateBlueprints)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      visible: false,
      thumbnailFileList: [],
      guideFileList: []
    }, _this.toggleModalVisible = function () {
      _this.setState(function (prevState) {
        return {
          visible: !prevState.visible
        };
      });
    }, _this.submitBlueprint = function (values) {
      _this.props.onCreate(values);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CreateBlueprints, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.blueprints.length !== this.props.blueprints.length && nextProps.loading === false) {
        this.setState({
          visible: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          blueprints = _props.blueprints,
          accounts = _props.accounts,
          fetchAccounts = _props.fetchAccounts,
          onDelete = _props.onDelete,
          onDuplicate = _props.onDuplicate,
          loading = _props.loading,
          mediaActionURLForThumbnails = _props.mediaActionURLForThumbnails,
          mediaActionURLForGuides = _props.mediaActionURLForGuides,
          mediaActionURLForAeFiles = _props.mediaActionURLForAeFiles,
          mediaFBActionUrl = _props.mediaFBActionUrl,
          WSSEToken = _props.WSSEToken,
          onUpload = _props.onUpload,
          uploadingMediaToFB = _props.uploadingMediaToFB;
      var visible = this.state.visible;


      return _react2.default.createElement(
        'div',
        { className: 'CreateBlueprints__Component' },
        _react2.default.createElement(
          _components.Header,
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/creative_at_scale' },
            _react2.default.createElement(_antd.Icon, { type: 'rollback' })
          ),
          'Create Blueprints'
        ),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              _antd.Button,
              { className: 'create-blueprint-button', disabled: loading, type: 'primary', onClick: this.toggleModalVisible },
              _react2.default.createElement(_antd.Icon, { type: 'plus' }),
              ' Create Blueprint'
            )
          ),
          _react2.default.createElement(
            _antd.Spin,
            { spinning: loading, style: { marginTop: '100px', marginRight: '50px' } },
            _react2.default.createElement(_components.Blueprint, {
              blueprints: blueprints,
              admin: true,
              onDelete: onDelete,
              onUpload: onUpload,
              onDuplicate: onDuplicate,
              fetchAccounts: fetchAccounts,
              accounts: accounts,
              WSSEToken: WSSEToken,
              mediaFBActionUrl: mediaFBActionUrl,
              uploadingMediaToFB: uploadingMediaToFB
            })
          ),
          _react2.default.createElement(_components.BlueprintModal, {
            visible: visible,
            loading: loading,
            onCancel: this.toggleModalVisible,
            onSubmit: this.submitBlueprint,
            WSSEToken: WSSEToken,
            mediaActionURLForThumbnails: mediaActionURLForThumbnails,
            mediaActionURLForGuides: mediaActionURLForGuides,
            mediaActionURLForAeFiles: mediaActionURLForAeFiles
          })
        )
      );
    }
  }]);
  return CreateBlueprints;
}(_react.Component), _class.propTypes = {
  loading: _propTypes2.default.bool.isRequired,
  fetchAccounts: _propTypes2.default.func.isRequired,
  onDelete: _propTypes2.default.func.isRequired,
  onCreate: _propTypes2.default.func.isRequired,
  onUpload: _propTypes2.default.func.isRequired,
  onDuplicate: _propTypes2.default.func.isRequired,
  blueprints: _Blueprint.BlueprintPropTypes.blueprints,
  accounts: _Blueprint.BlueprintPropTypes.accounts,
  mediaActionURLForThumbnails: _propTypes2.default.string,
  mediaActionURLForGuides: _propTypes2.default.string,
  mediaActionURLForAeFiles: _propTypes2.default.string,
  mediaFBActionUrl: _propTypes2.default.string,
  WSSEToken: _propTypes2.default.string,
  uploadingMediaToFB: _propTypes2.default.bool
}, _class.defaultProps = {
  blueprints: null,
  accounts: {
    loading: false,
    data: []
  },
  mediaActionURLForThumbnails: '',
  mediaActionURLForGuides: '',
  mediaActionURLForAeFiles: '',
  mediaFBActionUrl: '',
  WSSEToken: '',
  uploadingMediaToFB: false
}, _temp2);
exports.default = CreateBlueprints;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/modules/CreateBlueprints/components/CreateBlueprints.js
// module id = 3930
// module chunks = 7